import React from 'react'

import PropTypes from 'prop-types'
import { Redirect, useParams } from 'react-router-dom'

import { useBorrowerUrl, useUserType } from 'core/hooks'

import ActionDisabledMessage from './ActionDisabledMessage'

const agentText = `You cannot perform this action now. Some actions are limited due to the current loan's status. Please contact your supervisor for help.`

const LoanStatusMessageOrRedirect = ({ backUrl }) => {
  const userType = useUserType()
  const { loanId } = useParams()

  const url = backUrl || (loanId ? `/loans/${loanId}/activity` : '/loans')

  const borrowerUrl = useBorrowerUrl(url)

  if (userType === 'borrower') {
    return <Redirect to={borrowerUrl} />
  } else {
    return <ActionDisabledMessage message={agentText} backUrl={url} />
  }
}

LoanStatusMessageOrRedirect.propTypes = {
  backUrl: PropTypes.string,
}

export default LoanStatusMessageOrRedirect
